import { Form, Icon } from '@anytag/shared-atoms';
import { cn } from '@anytag/shared-utils';

export const styles = {
  section: cn('items-self-stretch flex flex-col rounded-sm bg-white p-6 shadow-container'),
  label: cn('text-lg font-semibold'),
  bcList: cn('flex flex-col gap-2 rounded-sm border-base-border bg-white px-6 py-4'),
  warning: cn('mt-6 mb-4 flex items-center rounded-sm border border-yellow-20 bg-yellow-10 p-2 text-sm'),
  adAccountChain: (isDisconnected: boolean) =>
    cn('bg-gray-20 flex h-6 w-6 items-center justify-center rounded-full', {
      'bg-black-60': isDisconnected,
      'bg-dark-green-20': !isDisconnected
    })
};

interface TikTokSectionTitleProps {
  isConnected: boolean;
  isActive?: boolean;
  title: string;
  index?: number;
  className?: string;
}
export const TikTokSectionTitle = ({ isConnected, title, className, index = 1, isActive }: TikTokSectionTitleProps) =>
  isConnected ? (
    <div className={cn('mb-2 flex items-center gap-2', className)}>
      <Icon icon="check" variant="white" size={20} className={cn('rounded-full bg-attention-green p-1')} />
      <label className={styles.label}>{title}</label>
    </div>
  ) : (
    <Form.SectionTitle
      index={index}
      size="20"
      label={title}
      className={cn(styles.label, { 'mb-2 opacity-100': isActive, 'opacity-30': !isActive })}
    />
  );
